import React from 'react';

import {useHistory} from 'react-router-dom';

import CloseImg from '../../../../../../../../../../assets/icons/addadminclose.svg';

import {AddAdminHeaderContainer} from './elements';

export const AddAdminHeader = () => {
  const history = useHistory();

  return (
    <AddAdminHeaderContainer>
      <div className="add-admin-header">
        <div className="add-admin-title">
          <div>
            <span className="add-admin-name">Add User</span>
          </div>
          <div>
            <button
              className="btn"
              id="closeBtn"
              onClick={() => {
                history.replace(`/admin/users/admin`);
              }}
              type="button"
            >
              <img alt="Options" src={CloseImg} />
            </button>
          </div>
        </div>
      </div>
    </AddAdminHeaderContainer>
  );
};
